// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610071616/js/" + chunkId + "." + {"44":"4593beb6","225":"4ecbe629","481":"591f17e7","486":"34acd319","770":"6006a4b9"}[chunkId] + ".0.5732841371344735.chunk.js";
};